import { render, staticRenderFns } from "./SupplierItemsForm.vue?vue&type=template&id=13af1664"
import script from "./SupplierItemsForm.vue?vue&type=script&lang=js"
export * from "./SupplierItemsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports